import type { Messages } from '../de';

export default {
  notLoaded: 'Activity not loaded: {error}',
  toList: 'back to list',
  loading: 'Loading …',
  back: 'Activities',
  backAria: 'Back to activities',
  editAria: 'Edit title and note',
  kpis: 'Key figures',
  kpi: {
    distance: 'Distance',
    time: 'Time',
    speed: 'Speed',
    pace: 'Pace',
    hr: 'Avg HR',
    elevation: 'Elevation',
    load: 'Load',
    hrTssEstimated: 'hrTSS est.',
    power: 'Avg power',
    energy: 'Energy',
    total: 'Total incl. pauses',
    rpe: 'Effort',
    rpeTip: 'Perceived exertion (RPE) on a 1–10 scale',
  },
  source: 'Source: {source}',
  fitOriginal: ' · original FIT',
  zonesTip: 'Zone version {n}, limits {floors} bpm',
  zonesChip: 'Zones v{n} · valid from {date}',
  download: 'Download FIT',
  noFit: 'No FIT file in the archive for this version',
  replacedKept: ' · the replaced version stays in the archive',
  fitFrom: 'FIT from {source}',
  route: 'Route',
  mapNote: 'Start only visible to you · hidden in Maps',
  media: {
    aria: 'Photos and videos',
    title: 'Photos',
    add: 'Add photo',
    uploading: 'Uploading …',
    failed: 'Not uploaded: {error}',
    heic: 'This browser cannot convert HEIC – please export as JPEG.',
    tooBig: 'Too large (at most {mb} MB).',
    atKm: 'at km {km}',
    video: 'Video',
    open: 'Open photo {n} of {total}',
    close: 'Close',
    prev: 'Previous',
    next: 'Next',
    caption: 'Caption',
    captionPlaceholder: 'Add a caption',
    save: 'Save',
    hide: 'Hide',
    show: 'Show',
    remove: 'Delete',
    removeConfirm: 'Delete this photo for good?',
    hiddenCount: { one: '{count} hidden', other: '{count} hidden' },
    showHidden: 'show',
    hideHidden: 'hide',
    fromStrava: 'from Strava',
    onMap: 'Photo on the map',
    empty: 'No photos yet.',
  },
  edit: {
    title: 'Title',
    note: 'Note',
    notePlaceholder: 'How did it go?',
    saving: 'Saving …',
    save: 'Save',
    cancel: 'Cancel',
    hint: 'Your own texts override every source and survive a rebuild.',
  },
  tags: {
    group: 'Tags',
    name: {
      Race: 'Race',
      DNF: 'DNF',
      'Long Run': 'Long run',
      Commute: 'Commute',
      'With Kid': 'With kid',
      'With Pet': 'With dog',
      Treadmill: 'Treadmill',
      'For a Cause': 'For a cause',
    },
    guessedDnf: 'detected: shorter than {dist} – not counted as a record',
    guessedRace: 'Race detected from title',
    notSaved: 'Not saved: {error}',
  },
  rating: {
    aria: 'Rating',
    driftTip: 'Ratio of {basis} to heart rate, second vs. first half of moving time',
    basisPower: 'power',
    basisPace: 'pace',
    drift: 'Heart rate drift',
    effTip: 'Distance per heartbeat (avg HR × moving minutes)',
    eff: 'Efficiency',
    perBeat: 'm/beat',
    baseline: 'Avg {sport}, prior 90 days: {v}',
    noBaseline: 'no comparison yet – no session of this sport in the prior 90 days',
    aerobic: 'Aerobic decoupling',
    aerobicTip: 'Pace per heart rate, second vs. first half of running time from minute 10, without walking and stops',
    aerobicBelow: 'below 5 % – likely under your aerobic threshold',
    aerobicAbove: '5 % or more – likely above your aerobic threshold',
    aerobicFacts: '{min} min from minute 10 · avg {hr} bpm ({first} → {second})',
    aerobicHelp: 'How to read it: below 5 % the run was likely under your aerobic threshold. This is a rule of thumb, no guarantee; heat, wind, hills and little sleep push the number up.',
    aerobicTest: 'As a drift test (60–75 min steady in the upper half of Z2): below 5 % → raise the top of Z2 by 2–3 bpm, above → lower it by 2–3 bpm.',
  },
  zones: {
    aria: 'Heart rate zones',
    title: 'Time in zones',
    noHr: 'No heart rate recorded – load is estimated (~).',
    noZones: 'No zones set for this day.',
    foot: 'Zones v{n} · valid from {date} · resting HR {rest}, max {max}',
  },
  laps: {
    title: 'Laps',
    time: 'Time',
    distance: 'Distance',
    speed: 'Speed',
    pace: 'Pace',
    hr: 'Avg HR',
    maxHr: 'Max HR',
    power: 'Avg power',
  },
  chart: {
    title: 'Charts',
    hint: 'Scroll wheel or two fingers to zoom',
    xAxis: 'x axis',
    distance: 'Distance',
    time: 'Time',
    speed: 'Speed',
    pace: 'Pace',
    hr: 'Heart rate (bpm)',
    power: 'Power (W)',
    alt: 'Elevation (m)',
    summary: 'Chart over {axis}: {panes}',
    overDistance: 'distance',
    overTime: 'time',
  },
} satisfies Messages['activity'];
